"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntragenSanctuaryHeadquarters = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRenderer_1 = require("../render/CardRenderer");
const ResourceType_1 = require("../../ResourceType");
const PlaceMoonColonyTile_1 = require("../../moon/PlaceMoonColonyTile");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const Card_1 = require("../Card");
const CardRenderItem_1 = require("../render/CardRenderItem");
class IntragenSanctuaryHeadquarters extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.INTRAGEN_SANCTUARY_HEADQUARTERS,
            tags: [Tags_1.Tags.ANIMAL, Tags_1.Tags.MOON],
            startingMegaCredits: 38,
            resourceType: ResourceType_1.ResourceType.ANIMAL,
            initialActionText: 'Place a colony tile on the Moon.',
            metadata: {
                description: 'You start with 38 M€. As your first action, place a colony tile on the Moon and raise the Colony Rate 1 step.',
                cardNumber: 'MC8',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br;
                    b.megacredits(38).moonColony().secondaryTag(CardRenderItem_1.AltSecondaryTag.MOON_COLONY_RATE);
                    b.corpBox('effect', (ce) => {
                        ce.effect('When any player plays an animal tag (including this), add 1 animal to this card.', (eb) => {
                            eb.animals(1).any.played.startEffect.animals(1);
                            eb.vpText('1 VP for every 2 animals on this card.');
                        });
                    });
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.animals(1, 2),
            },
        });
        this.resourceCount = 0;
    }
    initialAction(player) {
        player.game.defer(new PlaceMoonColonyTile_1.PlaceMoonColonyTile(player));
        return undefined;
    }
    play() {
        this.resourceCount = 1;
        return undefined;
    }
    ;
    onCorpCardPlayed(player, card) {
        return this.onCardPlayed(player, card);
    }
    onCardPlayed(player, card) {
        const count = card.tags.filter((tag) => tag === Tags_1.Tags.ANIMAL).length;
        player.addResourceTo(this, count);
        return undefined;
    }
    getVictoryPoints() {
        return Math.floor(this.resourceCount / 2);
    }
}
exports.IntragenSanctuaryHeadquarters = IntragenSanctuaryHeadquarters;
//# sourceMappingURL=IntragenSanctuaryHeadquarters.js.map